import axios from 'axios'
import { Formik, useFormik } from 'formik'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import * as Yup from 'yup';
import { CompanyContext } from '../../../Context/CompanyContext.js'
import { TestContext } from '../../../Context/TestContext.js'
import { UserContext } from '../../../Context/UserContext.js'
import { toast } from 'react-toastify'
import style from "./addTestAdmin.module.css"


export default function AddTestAdmin() {
   const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
   const [step, setStep] = useState("testOnly");
   const [search, setSearch] = useState([]);
   const [test, setTest] = useState("");
   const [show, setShow] = useState(false);
   const [testName, setTestName] = useState("");

   const { allCompanyInfo, getAllCompanyInfo } = useContext(CompanyContext);
   const { getAllTests, tests } = useContext(TestContext);
   const { userToken } = useContext(UserContext);
   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }





   async function submitAddTestOnly(values) {
      setLoading(true)
      let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/test/addTestOnly`, values, { headers: header })
         .catch((error) => {
            setLoading(false)
            Swal.fire({
               title: error.response.data.message,
               text: "Please Try Again",
               icon: "error"
            });
         });

      if (response?.data.message === "success") {
         setLoading(false)
         Swal.fire({
            position: "top-end",
            icon: "success",
            title: response?.data.message,
            showConfirmButton: false,
            timer: 1500
         });
         navigate('/dashBoard/testDashboard')
      }
   }
   let validationSchemaTestOnly = Yup.object({
      name: Yup.string().min(2, "Name Should be More than 2").max(50, "Name less than 50").required("Name is Required").trim(),
      description: Yup.string().min(2, "Description Should be More than 2").max(500, "Description less than 50").trim(),
      condition: Yup.string().min(2, "Condition Should be More than 2").max(500, "Condition less than 50").trim(),
   })
   let formikTestOnly = useFormik({
      initialValues: {
         name: "",
         description: "",
         condition: "",
      }, validationSchemaTestOnly,
      onSubmit: submitAddTestOnly
   })





   async function submitAddTest(values) {
      setLoading(true);
      let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/test`, values, { headers: header })
         .catch((error) => {
            setLoading(false);
            Swal.fire({
               title: error.response.data.message,
               text: "Please Try Again",
               icon: "error"
            });
         });

      if (response?.data.message === "success") {
         setLoading(false);
         Swal.fire({
            position: "top-end",
            icon: "success",
            title: response?.data.message,
            showConfirmButton: false,
            timer: 1500
         });
         navigate('/dashBoard/testDashboard')
      }
   }
   let validationSchemaTest = Yup.object({
      name: Yup.string().min(2, "Name Should be More than 2").max(50, "Name less than 50").required("Name is Required").trim(),
      description: Yup.string().min(2, "Description Should be More than 2").max(500, "Description less than 50").trim(),
      condition: Yup.string().min(2, "Condition Should be More than 2").max(500, "Condition less than 50").trim(),
      company: Yup.string().max(24, "Company less than 14").required("Company is Required"),
      price: Yup.number().required(),
      priceAfterDiscount: Yup.number().required(),
      contract_Price: Yup.number().required(),
   })
   let formikTest = useFormik({
      initialValues: {
         name: "",
         description: "",
         condition: "",
         company: "",
         price: "",
         priceAfterDiscount: "",
         contract_Price: ""
      }, validationSchemaTest,
      onSubmit: submitAddTest
   })





   async function submitAddPrice(values) {
      setLoading(true);
      let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/price`, values, { headers: header })
         .catch((error) => {
            setLoading(false);
            Swal.fire({
               title: error.response.data.message,
               text: "Please Try Again",
               icon: "error"
            });
         });

      if (response?.data.message === "success") {
         setLoading(false);
         Swal.fire({
            position: "top-end",
            icon: "success",
            title: response?.data.message,
            showConfirmButton: false,
            timer: 1500
         });
         navigate('/dashBoard/testDashboard')
      }
   }
   let validationSchemaPrice = Yup.object({
      test: Yup.string().max(24, "Company less than 14").required("Company is Required"),
      company: Yup.string().max(24, "Company less than 14").required("Company is Required"),
      price: Yup.number().required(),
      priceAfterDiscount: Yup.number().required(),
      contract_Price: Yup.number().required(),
   })
   let formikPrice = useFormik({
      initialValues: {
         test: "",
         company: "",
         price: "",
         priceAfterDiscount: "",
         contract_Price: ""
      }, validationSchemaPrice,
      onSubmit: submitAddPrice
   })

   //& Search Test By Test Name :
   function searchInput(e) {
      if (e.target.value === "") {
         setSearch([])
      }
      if (e.target.value.length >= 3) {
         getSearchData((e.target.value).toLowerCase())
      }
   }
   //& Search Test By Test Name :
   function handleAddTest(formik, id, name) {
      setTest(id);
      setSearch([]);
      setShow(true);
      setTestName(name);
      formik.values.test = id;
   }
   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      let response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/test?keyword=${search}`)
         .catch((error) => {
            toast.warn(error.response.data.message + " Or Not Found", {
               position: "top-right"
            });
         })
      if (response?.data.message === "success") {
         setSearch(response?.data.tests)
      }
   }





   async function submitUpdatePrice(values) {
      console.log(values);

      setLoading(true);
      let response = await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/price`, values, { headers: header })
         .catch((error) => {
            setLoading(false);
            Swal.fire({
               position: "top-end",
               icon: "error",
               title: error.response.data.message,
               showConfirmButton: false,
               timer: 1500
            });
         });

      if (response?.data.message === "success") {
         setLoading(false);
         Swal.fire({
            position: "top-end",
            icon: "success",
            title: response?.data.message,
            showConfirmButton: false,
            timer: 1500
         });
         navigate('/dashBoard/testDashboard')
      }
   }
   let validationSchemaUpdatePrice = Yup.object({
      test: Yup.string().max(24, "Company less than 14").required("Company is Required"),
      company: Yup.string().max(24, "Company less than 14").required("Company is Required"),
      price: Yup.number().required(),
      priceAfterDiscount: Yup.number().required(),
      contract_Price: Yup.number().required(),
   })
   let formikUpdatePrice = useFormik({
      initialValues: {
         test: "",
         company: "",
         price: "",
         priceAfterDiscount: "",
         contract_Price: ""
      }, validationSchemaUpdatePrice,
      onSubmit: submitUpdatePrice
   })


   useEffect(() => {
      getAllCompanyInfo();
      getAllTests();
   }, [])

   return (
      <Fragment>
         <div className="container addTestAdmin ">
            <div className='row'>
               <div className='col-md-8 offset-md-2'>
                  <h1 className="main-header mt-0">Add new test and price</h1>
                  <div className='under-header'></div>



                  <div className='d-flex justify-content-around'>
                     <div>
                        <button className='btn btn-sm bg-main' disabled={step === "testOnly"} onClick={() => { setStep("testOnly") }}>Add Test Only</button>
                     </div>

                     <div>
                        <button className='btn btn-sm bg-main' disabled={step === "test"} onClick={() => { setStep("test") }}>Add Test</button>
                     </div>

                     <div>
                        <button className='btn btn-sm bg-main' disabled={step === "price"} onClick={() => { setStep("price") }}>Add Price</button>
                     </div>

                     <div>
                        <button className='btn btn-sm bg-main' disabled={step === "updatePrice"} onClick={() => { setStep("updatePrice") }}>Update Price</button>
                     </div>
                  </div>



                  {step === "testOnly" ? <>
                     <form action="" onSubmit={formikTestOnly.handleSubmit}>
                        <h5 className='fw-bold mt-2'>Add New Test Without Price </h5>
                        <h6 className='mt-4'><i className="fa-solid fa-flask-vial me-2"></i>  Please Enter Information Test </h6>

                        <div className="my-4">
                           <label htmlFor="name" className="form-label">Enter Test Name</label>
                           <input type="text"
                              value={formikTestOnly.values.name}
                              onChange={formikTestOnly.handleChange}
                              onBlur={formikTestOnly.handleBlur}
                              className="form-control" id="name"
                              name="name"
                              placeholder="Test Name" />
                           {formikTestOnly.errors.name && formikTestOnly.touched.name ? <div className="alert alert-danger mt-4 p-2">{formikTestOnly.errors.name}</div> : ""}
                        </div>

                        <div className="my-4">
                           <label htmlFor="description" className="form-label">Write Description</label>
                           <input type="text"
                              value={formikTestOnly.values.description}
                              onChange={formikTestOnly.handleChange}
                              onBlur={formikTestOnly.handleBlur}
                              className="form-control" id="description"
                              name="description"
                              placeholder="Write Description" />
                           {formikTestOnly.errors.description && formikTestOnly.touched.description ? <div className="alert alert-danger mt-4 p-2">{formikTestOnly.errors.description}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="condition" className="form-label">Write Test Condition</label>
                           <input type="text"
                              value={formikTestOnly.values.condition}
                              onChange={formikTestOnly.handleChange}
                              onBlur={formikTestOnly.handleBlur}
                              className="form-control" id="condition"
                              name="condition"
                              placeholder="Write Test Condition" />
                           {formikTestOnly.errors.condition && formikTestOnly.touched.condition ? <div className="alert alert-danger mt-4 p-2">{formikTestOnly.errors.condition}</div> : ""}
                        </div>

                        <div className="d-grid gap-2 col-6 mx-auto">
                           {loading ?
                              <button className="btn bg-main text-white btn-sm mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <button disabled={!(formikTestOnly.isValid && formikTestOnly.dirty)} type="submit" className="btn bg-main text-white btn-sm mt-2">Add Test Only</button>
                           }
                        </div>
                     </form>
                  </> : ""}



                  {step === "test" ? <>
                     <form action="" onSubmit={formikTest.handleSubmit}>
                        <h5 className='fw-bold mt-2'>Add Test With In Price</h5>
                        <h6 className='mt-4'><i className="fa-solid fa-flask-vial me-2"></i>  Please Enter Information Test </h6>

                        <div className="my-4">
                           <label htmlFor="name" className="form-label">Enter Test Name</label>
                           <input type="text"
                              value={formikTest.values.name}
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              className="form-control" id="name"
                              name="name"
                              placeholder="Test Name" />
                           {formikTest.errors.name && formikTest.touched.name ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.name}</div> : ""}
                        </div>

                        <div className="my-4">
                           <label htmlFor="description" className="form-label">Write Description</label>
                           <input type="text"
                              value={formikTest.values.description}
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              className="form-control" id="description"
                              name="description"
                              placeholder="Write Description" />
                           {formikTest.errors.description && formikTest.touched.description ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.description}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="condition" className="form-label">Write Test Condition</label>
                           <input type="text"
                              value={formikTest.values.condition}
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              className="form-control" id="condition"
                              name="condition"
                              placeholder="Write Test Condition" />
                           {formikTest.errors.condition && formikTest.touched.condition ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.condition}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="company" className="form-label">Enter Company</label>
                           <select name="company" id="company" className="form-control"
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              value={formikTest.values.company} >

                              <option value="">Select Company</option>
                              {allCompanyInfo.map((ele) => {
                                 return (
                                    <option value={ele._id}>{ele.name}</option>
                                 )
                              })}
                           </select>

                           {formikTest.errors.company && formikTest.touched.company ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.company}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="price" className="form-label">Enter Price</label>
                           <input type="number"
                              value={formikTest.values.price}
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              className="form-control" id="price"
                              name="price"
                              placeholder="Price" />
                           {formikTest.errors.price && formikTest.touched.price ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.price}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="priceAfterDiscount" className="form-label">Enter Price After Discount</label>
                           <input type="number"
                              value={formikTest.values.priceAfterDiscount}
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              className="form-control" id="priceAfterDiscount"
                              name="priceAfterDiscount"
                              placeholder="Price After Discount" />
                           {formikTest.errors.priceAfterDiscount && formikTest.touched.priceAfterDiscount ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.priceAfterDiscount}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="contract_Price" className="form-label">Enter Contract Price</label>
                           <input type="number"
                              value={formikTest.values.contract_Price}
                              onChange={formikTest.handleChange}
                              onBlur={formikTest.handleBlur}
                              className="form-control" id="contract_Price"
                              name="contract_Price"
                              placeholder="Contract Price" />
                           {formikTest.errors.contract_Price && formikTest.touched.contract_Price ? <div className="alert alert-danger mt-4 p-2">{formikTest.errors.contract_Price}</div> : ""}
                        </div>



                        <div className="d-grid gap-2 col-6 mx-auto">
                           {loading ?
                              <button className="btn bg-main text-white btn-sm mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <button disabled={!(formikTest.isValid && formikTest.dirty)} type="submit" className="btn bg-main text-white btn-sm mt-2">Add Test</button>
                           }
                        </div>
                     </form>
                  </> : ""}




                  {step === "price" ? <>
                     <form action="" onSubmit={formikPrice.handleSubmit}>
                        <h5 className='fw-bold mt-2'>Add New Price </h5>
                        <h6 className='mt-4'><i className="fa-solid fa-money-check-dollar me-2"></i>Please Enter Information Price : </h6>

                        <div className="my-4">
                           <div className="">
                              <form >
                                 <div className='position-relative'>
                                    <i className={`${style.icon_search} fa-solid fa-microscope icon_search`}></i>
                                    <input type="search" onChange={(e) => { searchInput(e) }} className='form-control py-4' id='test_search' placeholder='Select Test' name="search" />
                                 </div>
                              </form>

                              {search.length ?
                                 <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                                    {search.map((ele) => <p key={ele._id} onClick={() => { handleAddTest(formikPrice, ele._id, ele.name) }} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success '>{ele.name}</p>)}
                                 </div>
                                 : ""
                              }

                              {show ?
                                 <div className="container">
                                    <div className="row">
                                       <div className=''>
                                          <div className="p-1 py-2 bg-light rounded-2 my-1 row align-items-center border border-1">
                                             <div className="col-6 p-0">
                                                <div>
                                                   <p className="text-center fw-bold  m-0">
                                                      {testName}
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 :
                                 ""
                              }
                           </div>
                        </div>

                        <div className="my-4">
                           <label htmlFor="company" className="form-label">Enter Company</label>
                           <select name="company" id="company" className="form-control"
                              onChange={formikPrice.handleChange}
                              onBlur={formikPrice.handleBlur}
                              value={formikPrice.values.company} >

                              <option value="">Select Company</option>
                              {allCompanyInfo.map((ele) => {
                                 return (
                                    <option value={ele._id}>{ele.name}</option>
                                 )
                              })}
                           </select>

                           {formikPrice.errors.company && formikPrice.touched.company ? <div className="alert alert-danger mt-4 p-2">{formikPrice.errors.company}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="price" className="form-label">Enter Price Before Discount </label>
                           <input type="number"
                              value={formikPrice.values.price}
                              onChange={formikPrice.handleChange}
                              onBlur={formikPrice.handleBlur}
                              className="form-control" id="price"
                              name="price"
                              placeholder="Price" />
                           {formikPrice.errors.price && formikPrice.touched.price ? <div className="alert alert-danger mt-4 p-2">{formikPrice.errors.price}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="priceAfterDiscount" className="form-label">Enter Price After Discount</label>
                           <input type="number"
                              value={formikPrice.values.priceAfterDiscount}
                              onChange={formikPrice.handleChange}
                              onBlur={formikPrice.handleBlur}
                              className="form-control" id="priceAfterDiscount"
                              name="priceAfterDiscount"
                              placeholder="Price After Discount" />
                           {formikPrice.errors.priceAfterDiscount && formikPrice.touched.priceAfterDiscount ? <div className="alert alert-danger mt-4 p-2">{formikPrice.errors.priceAfterDiscount}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="contract_Price" className="form-label">Enter Contract Price</label>
                           <input type="number"
                              value={formikPrice.values.contract_Price}
                              onChange={formikPrice.handleChange}
                              onBlur={formikPrice.handleBlur}
                              className="form-control" id="contract_Price"
                              name="contract_Price"
                              placeholder="Contract Price" />
                           {formikPrice.errors.contract_Price && formikPrice.touched.contract_Price ? <div className="alert alert-danger mt-4 p-2">{formikPrice.errors.contract_Price}</div> : ""}
                        </div>


                        <div className="d-grid gap-2 col-6 mx-auto">
                           {loading ?
                              <button className="btn bg-main text-white btn-sm mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <button disabled={!(formikPrice.isValid && formikPrice.dirty)} type="submit" className="btn bg-main text-white btn-sm mt-2">Add Price</button>
                           }
                        </div>

                     </form>
                  </> : ""}




                  {step === "updatePrice" ? <>
                     <form action="" onSubmit={formikUpdatePrice.handleSubmit}>
                        <h5 className='fw-bold mt-2'>Update Price </h5>
                        <h6 className='mt-4'><i className="fa-solid fa-money-check-dollar me-2"></i>Please Enter Updated Price : </h6>

                        {/* <div className="my-4">
                                 <label htmlFor="test" className="form-label">Enter Test Name</label>
                                 <select name="test" id="test"  className="form-control"
                                       onChange={formikUpdatePrice.handleChange} 
                                       onBlur={formikUpdatePrice.handleBlur} 
                                       value={formikUpdatePrice.values.test} >

                                    <option value="">Select Test Name</option>
                                    {tests.map((ele)=>{
                                       return (
                                          <option value={ele._id}>{ele.name}</option>
                                       )
                                    })}      
                                 </select>

                                 {formikUpdatePrice.errors.name && formikUpdatePrice.touched.name?<div className="alert alert-danger mt-4 p-2">{formikUpdatePrice.errors.name}</div> :""}
                              </div> */}


                        <div className="my-4">
                           <div className="">
                              <form >
                                 <div className='position-relative'>
                                    <i className={`${style.icon_search} fa-solid fa-microscope icon_search`}></i>
                                    <input type="search" onChange={(e) => { searchInput(e) }} className='form-control py-4' id='test_search' placeholder='Select Test' name="search" />
                                 </div>
                              </form>

                              {search.length ?
                                 <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                                    {search.map((ele) => <p key={ele._id} onClick={() => { handleAddTest(formikUpdatePrice, ele._id, ele.name) }} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success '>{ele.name}</p>)}
                                 </div>
                                 : ""
                              }

                              {show ?
                                 <div className="container">
                                    <div className="row">
                                       <div className=''>
                                          <div className="p-1 py-2 bg-light rounded-2 my-1 row align-items-center border border-1">
                                             <div className="col-6 p-0">
                                                <div>
                                                   <p className="text-center fw-bold  m-0">
                                                      {testName}
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 :
                                 ""
                              }
                           </div>
                        </div>

                        <div className="my-4">
                           <label htmlFor="company" className="form-label">Enter Company</label>
                           <select name="company" id="company" className="form-control"
                              onChange={formikUpdatePrice.handleChange}
                              onBlur={formikUpdatePrice.handleBlur}
                              value={formikUpdatePrice.values.company} >

                              <option value="">Select Company</option>
                              {allCompanyInfo.map((ele) => {
                                 return (
                                    <option value={ele._id}>{ele.name}</option>
                                 )
                              })}
                           </select>

                           {formikUpdatePrice.errors.company && formikUpdatePrice.touched.company ? <div className="alert alert-danger mt-4 p-2">{formikUpdatePrice.errors.company}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="price" className="form-label">Enter Price</label>
                           <input type="number"
                              value={formikUpdatePrice.values.price}
                              onChange={formikUpdatePrice.handleChange}
                              onBlur={formikUpdatePrice.handleBlur}
                              className="form-control" id="price"
                              name="price"
                              placeholder="Price" />
                           {formikUpdatePrice.errors.price && formikUpdatePrice.touched.price ? <div className="alert alert-danger mt-4 p-2">{formikUpdatePrice.errors.price}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="priceAfterDiscount" className="form-label">Enter Price After Discount</label>
                           <input type="number"
                              value={formikUpdatePrice.values.priceAfterDiscount}
                              onChange={formikUpdatePrice.handleChange}
                              onBlur={formikUpdatePrice.handleBlur}
                              className="form-control" id="priceAfterDiscount"
                              name="priceAfterDiscount"
                              placeholder="Price After Discount" />
                           {formikUpdatePrice.errors.priceAfterDiscount && formikUpdatePrice.touched.priceAfterDiscount ? <div className="alert alert-danger mt-4 p-2">{formikUpdatePrice.errors.priceAfterDiscount}</div> : ""}
                        </div>


                        <div className="my-4">
                           <label htmlFor="contract_Price" className="form-label">Enter Contract Price</label>
                           <input type="number"
                              value={formikUpdatePrice.values.contract_Price}
                              onChange={formikUpdatePrice.handleChange}
                              onBlur={formikUpdatePrice.handleBlur}
                              className="form-control" id="contract_Price"
                              name="contract_Price"
                              placeholder="Contract Price" />
                           {formikUpdatePrice.errors.contract_Price && formikUpdatePrice.touched.contract_Price ? <div className="alert alert-danger mt-4 p-2">{formikUpdatePrice.errors.contract_Price}</div> : ""}
                        </div>


                        <div className="d-grid gap-2 col-6 mx-auto">
                           {loading ?
                              <button className="btn bg-main text-white btn-sm mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <button disabled={!(formikUpdatePrice.isValid && formikUpdatePrice.dirty)} type="submit" className="btn bg-main text-white btn-sm mt-2">Add Price</button>
                           }
                        </div>

                     </form>
                  </> : ""}
               </div>
            </div>



            {/* <div className="row">
               <div>
                  <div className="col-md-8 offset-md-2">
                     <form >
                        <div className='position-relative'>
                           <i className={`${style.icon_search} fa-solid fa-microscope icon_search`}></i>
                           <input type="search" onChange={(e)=>{searchInput(e)}}  className='form-control py-4' id='test_search' placeholder='أضافة  خدمات جديدة'  name="search" />
                        </div>
                     </form>

                     {search.length? 
                        <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                           {search.map((ele)=> <p key={ele._id} onClick={()=>handleAddTest(ele._id , ele.name)} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success cursor'>{ele.name}</p>)}
                        </div>
                        : ""
                     }

                     {show? 
                        <div className="container">
                           <div className="row">
                                 <div className='btn'>
                                    <div className="p-1 py-2 bg-light rounded-2 my-1 row align-items-center border border-1">
                                       <div className="col-6 p-0">
                                          <div>
                                             <p className="text-center fw-bold  m-0">
                                                {testName}
                                             </p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                        </div>
                        :
                        ""
                     }
                  </div>
               </div>
            </div> */}
         </div>
      </Fragment>
   )
}
